import React from 'react';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { BaseText, IconTouchable } from '@components';
import { IS_WEB } from '@utils';

const Container = styled(View)({
  flex: 1,
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const Title = styled(BaseText)({
  color: '$heading800',
  fontWeight: 'semi',
  variant: IS_WEB ? 'text.xlarge' : 'text.large',
});

export interface ITimestampsListHeaderProps {
  onPressClose(): void;
}

export const TimestampsListHeader =
  observer<ITimestampsListHeaderProps>(({ onPressClose }) => {
    const { t } = useTranslation();

    return (
      <Container>
        <Title>{t('tutorial.timestamps')}</Title>
        <IconTouchable
          name="close-light"
          color="$text400"
          size={24}
          onPress={onPressClose}
        />
      </Container>
    );
  });
